import React from "react";
import { Link } from "react-router-dom";

function NavAction({ classNav }) {
  return (
    <div>
      <ul className="mt-8">
        <li className={classNav}>
          <Link to="/cerita">
            <a>Cerita Sedikit</a>
          </Link>
        </li>
        <li className={classNav}>
          <Link to="/karya">
            <a>Project/Karya</a>
          </Link>
        </li>
        <li className={classNav}>
          <Link to="/motivasi">
            <a>Motivasi Belajar</a>
          </Link>
        </li>
      </ul>
      <hr className="w-full md:w-3/5 border-1 border-slate-700 mt-12" />
      <p className="mt-4 mb-6">
        <Link to="/kontak">
          <span className={classNav}>Kontak</span>
        </Link>
        <span> / </span>
        <a href="https://www.upwork.com/freelancers/~010d4f2277d1a7a563">
          <span className={classNav}>Hire me on Upwork</span>
        </a>
        <span> / </span>
        <a href="https://mubin-mhd.github.io/undangresepsi/">
          <span className={classNav}>undangresepsi</span>
        </a>
      </p>
      <hr className="w-full md:w-3/5 border-1 border-slate-700 mt-5 mb-10" />
    </div>
  );
}

export default NavAction;
